import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch past catering orders for a customer
 * @param {string} customerId - Customer ID
 * @param {string} customerType - Customer type ("individual" or "corporate")
 * @param {string} companyId - Company ID (optional, for corporate customers)
 * @returns {Promise<Object>} - Response data from the API
 */
export const getCateringPastOrdersApi = async (customerId, customerType = "individual", companyId = "") => {
  try {
    const params = new URLSearchParams({
      customer_id: customerId,
      customer_type: customerType,
      company_id: companyId
    });

    const response = await apiClient.get(
      `${API_ENDPOINTS.CATERING_PAST_ORDERS}?${params.toString()}`
    );
    return response.data; // Return the fetched data
  } catch (error) {
    handleApiError(error); // Handle API errors centrally
    throw error;
  }
};
